// react
import { useCallback, useContext } from 'react';

// context
import { ContextProject } from '../components/pages/Project/Project.context';

// config
import { featureFlags } from '../config/featureFlags';

// props
export interface GetCurrenciesForExchangeRatesParams {
	currency: string;
	currenciesExtra?: string[];
}

export interface UseExchangeRatesReturn {
	getCurrenciesForExchangeRates: (params: GetCurrenciesForExchangeRatesParams) => string[];
}

// hook
export const useExchangeRates = (): UseExchangeRatesReturn => {
	const { project } = useContext(ContextProject);

	const getCurrenciesForExchangeRates = useCallback(
		({ currency, currenciesExtra = [] }: GetCurrenciesForExchangeRatesParams) => {
			let projectCurrencies: string[] = [];

			if (featureFlags['IFRS']) {
				projectCurrencies = project?.currencies?.map((c) => c.currency) || [];
			}

			const currencies = [...projectCurrencies, ...currenciesExtra];

			const currenciesFiltered = currencies.filter((curr) => curr !== currency);

			return [...new Set(currenciesFiltered)];
		},
		[project?.currencies]
	);

	return {
		getCurrenciesForExchangeRates,
	};
};
